import React, { Component } from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookShareCount,
  GooglePlusShareCount,
  LinkedinShareCount,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon
} from "react-share";
import urljoin from "url-join";

import config from '../../config/website';
// import "./SocialLinks.css";

class SocialLinks extends Component {
  renderShareCount = count => {
    const filter = count => (count > 0 ? count : "");
    return <div className="share-count">{filter(count)}</div>;
  }

  render() {
    const { slug, title: { text: title }, excerpt } = this.props;
    console.log({
      config,
      slug,
    });
    const url = urljoin(config.siteUrl, slug);
    // const url = urljoin(config.siteUrl, config.pathPrefix, slug);

console.log(`%curl: ${url}`, 'background:#bada55; color:#222;', this.props);
    const iconSize = 48;

    return (
      <div className="template__share">
          <div className="bold">Share</div>
          <span className="template__share-link">
            <TwitterShareButton url={url} title={title}>
             Twitter
            </TwitterShareButton>
          </span>

           <span className="template__share-link">
            <FacebookShareButton url={url} quote={excerpt}>
            Facebook
              {/* <FacebookShareCount url={url}>
                {count => this.renderShareCount(count)}
              </FacebookShareCount> */}
            </FacebookShareButton>
         </span>

           <span className="template__share-link">
            <LinkedinShareButton
              url={url}
              title={title}
              description={excerpt}
            >
             LinkedIn
              <LinkedinShareCount url={url}>
                {count => this.renderShareCount(count)}
              </LinkedinShareCount>
            </LinkedinShareButton>
            </span>
           <span className="template__share-link">
              
           </span>
      </div>
    );
  }
}

export default SocialLinks;



// WEBPACK FOOTER //
// ./src/components/SocialLinks.jsx